/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `submitted` - 제출됨
 * `processing` - 처리 중
 * `completed` - 완료
 * `failed` - 실패
 */
export type MusicVideoClipStatusEnum =
  (typeof MusicVideoClipStatusEnum)[keyof typeof MusicVideoClipStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MusicVideoClipStatusEnum = {
  pending: "pending",
  submitted: "submitted",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;
